window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.dashboard = {

    render: async function (container) {
        // --- 1. Immersive Mode (Sidebar Collapse) ---
        const sidebar = document.querySelector('.sidebar');
        if (sidebar && !sidebar.classList.contains('collapsed')) {
            if (window.toggleSidebar) window.toggleSidebar();
            else sidebar.classList.add('collapsed');
        }

        // --- 2. Inject V4 CSS ---
        if (!document.getElementById('dashboard-v4-style')) {
            const style = document.createElement('style');
            style.id = 'dashboard-v4-style';
            style.innerHTML = `
                :root {
                    --dash-primary: #059669; --dash-primary-dark: #064e3b;
                    --dash-bg: #f3f4f6; --dash-surface: #ffffff;
                    --dash-text: #1e293b; --dash-text-muted: #64748b;
                    --dash-border: #e2e8f0;
                }
                /* Ticker */
                .ticker-wrap { width: 100%; background: #0f172a; color: white; height: 30px; line-height: 30px; overflow: hidden; display: flex; font-size: 0.8rem; z-index: 10; }
                .ticker-item { padding: 0 20px; border-right: 1px solid #334155; white-space: nowrap; display:flex; gap:8px; align-items:center; }
                .ticker-val.up { color: #4ade80; } .ticker-val.down { color: #f87171; }
                
                /* Layout Holístico */
                .dash-main-container { display: flex; flex-direction: column; height: calc(100vh - 60px); background: var(--dash-bg); overflow: hidden; }
                .dash-grid { display: grid; grid-template-columns: 280px 1fr 320px; gap: 24px; padding: 20px; flex: 1; overflow-y: auto; }
                @media (max-width: 1400px) { .dash-grid { grid-template-columns: 1fr 320px; } .col-left { display: none; } }
                
                /* Cards Custom */
                .dash-card { background: var(--dash-surface); border-radius: 16px; padding: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 20px; border: 1px solid var(--dash-border); transition: transform 0.2s; position: relative; overflow: hidden; }
                .dash-card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1); }
                .dash-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
                .dash-title { font-weight: 600; color: var(--dash-text); display: flex; align-items: center; gap: 8px; font-size: 1rem; }
                
                /* Weather Glass Premium */
                .weather-glass {
                    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
                    border-radius: 20px; padding: 24px; color: white;
                    margin-bottom: 24px; position: relative; overflow: hidden;
                    box-shadow: 0 10px 30px -5px rgba(30, 64, 175, 0.4);
                    display: flex; align-items: center; justify-content: space-between;
                    gap: 30px;
                }
                .weather-glass::before { 
                    content: ''; position: absolute; top: -50%; right: -10%; width: 100%; height: 200%; 
                    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%); 
                    transform: rotate(-15deg); pointer-events: none; 
                }
                .weather-current { flex: 1; border-right: 1px solid rgba(255,255,255,0.15); padding-right: 30px; }
                .weather-forecast-side { flex: 1.5; display: flex; justify-content: space-around; gap: 15px; }
                .weather-badge { background: rgba(255, 255, 255, 0.15); padding: 5px 12px; border-radius: 25px; font-weight: 500; backdrop-filter: blur(8px); font-size: 0.75rem; border: 1px solid rgba(255,255,255,0.1); }
                .forecast-day-mini { text-align: center; min-width: 80px; }

                /* Bot Feed & Items */
                .bot-feed-list { flex: 1; overflow-y: auto; padding: 15px; background: #fff; }
                .bot-feed-item { display: flex; gap: 12px; padding: 12px; border-bottom: 1px solid #f1f5f9; transition: background 0.2s; border-radius: 8px; margin-bottom: 8px; }
                .bot-feed-item:hover { background: #f8fafc; }
                .bot-icon { width: 44px; height: 44px; border-radius: 12px; background: #f0fdf4; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 1.4rem; }
                .bot-icon i { line-height: 1; }
                .fab { font-family: "Font Awesome 6 Brands" !important; font-weight: 400 !important; }
                .fas { font-family: "Font Awesome 6 Free" !important; font-weight: 900 !important; }
                
                /* Mini KPIs */
                .kpi-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px dashed var(--dash-border); }
                .kpi-row:last-child { border-bottom: none; }

                /* Estilo bot aprovar (Padrão Inbox) */
                .btn-dash-action { padding: 4px 12px; font-size: 0.75rem; border-radius: 6px; border: none; cursor: pointer; font-weight: 600; }
                .btn-dash-primary { background: var(--dash-primary); color: white; }

            `;
            document.head.appendChild(style);
        }

        // --- 3. HTML Structure ---
        container.innerHTML = `
            <div class="dash-main-container">
                <!-- Ticker -->
                <div class="ticker-wrap">
                    <div class="ticker-item"><i class="fas fa-chart-line"></i> SOJA: <strong id="val-soja">R$ 132,50</strong> <span id="pct-soja" class="ticker-val down">▼ 0.5%</span></div>
                    <div class="ticker-item"><i class="fas fa-chart-line"></i> MILHO: <strong id="val-milho">R$ 58,20</strong> <span id="pct-milho" class="ticker-val up">▲ 1.2%</span></div>
                    <div class="ticker-item"><i class="fas fa-dollar-sign"></i> DÓLAR: <strong id="val-dolar">R$ 5,95</strong> <span id="pct-dolar" class="ticker-val up">▲ 0.3%</span></div>
                    <div class="ticker-item" id="ticker-weather">🌤️ Catalão: --°C</div>
                    <div class="ticker-item" style="margin-left:auto; font-size:0.75rem; color:#94a3b8;">Atualizado: <span id="last-update">--:--</span></div>
                </div>

                <!-- Header -->
                <div style="padding: 15px 20px; background: white; border-bottom: 1px solid var(--dash-border); display:flex; justify-content:space-between; align-items:center;">
                    <div>
                        <h1 style="margin:0; font-size:1.5rem; color:#0f172a; font-weight:700; font-family: 'Outfit';">Painel de Comando</h1>
                        <p style="margin:0; color:#64748b; font-size:0.9rem;">Visão Geral da Operação • Fazenda Rio do Peixe</p>
                    </div>
                    <div style="display:flex; gap:10px;">
                        <button class="btn btn-secondary" onclick="window.FazendaRP.Pages.dashboard.loadData(true)" title="Recarregar Dados"><i class="fas fa-sync-alt"></i></button>
                        <button class="btn btn-primary" onclick="window.FazendaRP.loadPage('financeiro_novo')"><i class="fas fa-plus"></i> Novo Lançamento</button>
                    </div>
                </div>

                <!-- Main Grid -->
                <div class="dash-grid">
                    
                    <!-- LEFT COL: Finance Snapshot -->
                    <div class="col-left">
                        
                        <!-- Saldo Card -->
                        <div class="dash-card" style="background: #1e1b4b; color: white; border: none;">
                            <div style="font-size: 0.85rem; opacity: 0.7; margin-bottom: 5px; font-weight: 500;">SALDO DISPONÍVEL</div>
                            <div id="dash-saldo" style="font-size: 2rem; font-weight: 700; font-family: 'Outfit';">R$ --</div>
                            
                            <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid rgba(255,255,255,0.1); display: flex; justify-content: space-between; font-size: 0.85rem;">
                                <span><i class="fas fa-arrow-up" style="color:#4ade80"></i> Rec: <span id="dash-rec-30d">0</span></span>
                                <span><i class="fas fa-arrow-down" style="color:#f87171"></i> Desp: <span id="dash-desp-30d">0</span></span>
                            </div>
                        </div>

                        <!-- Em Atraso -->
                        <div class="dash-card" id="card-vencidos" style="display:none; background: #fef2f2; border: 1px solid #fecaca;">
                            <div class="dash-card-header" style="margin-bottom:0;">
                                <div class="dash-title" style="color: #991b1b;"><i class="fas fa-exclamation-circle" style="color: #dc2626;"></i> <span id="count-vencidos">0</span> Vencidos</div>
                                <button class="btn btn-sm btn-danger" style="font-size:0.7rem; padding: 2px 8px;" onclick="window.FazendaRP.loadPage('financeiro_agenda')">Resolver</button>
                            </div>
                        </div>

                        <!-- Vencendo 7 Dias -->
                        <div class="dash-card">
                            <div class="dash-card-header">
                                <div class="dash-title"><i class="fas fa-calendar-week" style="color: #f59e0b;"></i> Vencendo (7 dias) (<span id="count-pagar-hoje">0</span>)</div>
                            </div>
                            <div id="list-vencendo-hoje" style="max-height: 200px; overflow-y: auto;">
                                <div style="text-align:center; color:#ccc; padding:10px;">Nenhum pagamento hoje.</div>
                            </div>
                            <button class="btn btn-sm btn-light" style="width:100%; margin-top:15px; font-size: 0.8rem;" onclick="window.FazendaRP.loadPage('financeiro_agenda')">Ver Agenda Completa</button>
                        </div>

                        <!-- Diesel -->
                        <div class="dash-card" id="card-diesel">
                            <div class="dash-card-header">
                                <div class="dash-title"><i class="fas fa-gas-pump" style="color: #6366f1;"></i> Diesel</div>
                            </div>
                            <div id="estoque-critico-list">
                                <div style="text-align:center; color:#ccc; padding:10px;">Carregando...</div>
                            </div>
                        </div>

                    </div>

                    <!-- CENTER COL: Ops & Chart -->
                    <div class="col-center">
                        
                        <!-- Weather Hero -->
                        <div class="weather-glass">
                            <!-- Current Side -->
                            <div class="weather-current">
                                <div style="display: flex; align-items: center; gap: 8px; font-size: 0.8rem; opacity: 0.9; margin-bottom: 12px;">
                                    <i class="fas fa-location-dot"></i> Catalão, GO
                                </div>
                                <div style="display: flex; align-items: center; gap: 20px; margin-bottom: 12px;">
                                    <i class="fas fa-cloud-sun fa-3x" style="opacity: 0.9;" id="hero-icon"></i>
                                    <h2 style="font-size: 3.5rem; font-weight:800; margin:0; font-family:'Outfit';" id="hero-temp">--°C</h2>
                                    <div>
                                        <p style="margin: 0; font-weight: 600; font-size: 1.1rem; line-height: 1.2;" id="hero-cond">--</p>
                                        <div style="font-size: 0.8rem; opacity: 0.8; margin-top: 4px;"><i class="fas fa-wind"></i> <span id="hero-wind">--</span> | <i class="fas fa-tint"></i> <span id="hero-humidity">--</span></div>
                                    </div>
                                </div>
                                <div id="badge-spraying" class="weather-badge" style="display: inline-flex; align-items: center; gap: 6px; background: rgba(16, 185, 129, 0.4);">
                                    <i class="fas fa-leaf"></i> <strong id="hero-spraying" style="font-size: 0.7rem;">PULVERIZAÇÃO: OK</strong>
                                </div>
                            </div>

                            <!-- Forecast Side -->
                            <div class="weather-forecast-side" id="weather-forecast">
                                <!-- Forecast items injected here -->
                            </div>
                        </div>

                        <!-- Main Chart -->
                        <div class="dash-card" style="height: 400px; display: flex; flex-direction: column;">
                            <div class="dash-card-header">
                                <div class="dash-title">
                                    <div style="background: #ecfdf5; padding: 8px; border-radius: 8px; color: #059669; margin-right:8px;"><i class="fas fa-chart-area"></i></div>
                                    Fluxo de Caixa (6 Meses)
                                </div>
                                <div style="font-size: 0.75rem; color: var(--dash-text-muted);">Estimado vs Realizado</div>
                            </div>
                            <div style="flex: 1; position: relative;">
                                <canvas id="mainChart"></canvas>
                            </div>
                        </div>

                        <!-- Status Frota & Safra -->
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                            <div class="dash-card" style="margin-bottom:0;">
                                <div class="dash-title" style="margin-bottom:10px;"><i class="fas fa-tractor" style="color: #64748b;"></i> Frota Ativa</div>
                                <div style="display:flex; align-items: baseline; gap: 10px;">
                                    <span style="font-size: 2rem; font-weight: 700; color: #1e293b;" id="frota-total">--</span>
                                    <span style="color: #64748b; font-size: 0.9rem;" id="frota-sub">/ --</span>
                                </div>
                                <div style="font-size: 0.75rem; color: #16a34a; margin-top: 5px;" id="frota-manut">● -- na oficina</div>
                            </div>

                            <div class="dash-card" style="margin-bottom:0;">
                                <div class="dash-title" style="margin-bottom:10px;"><i class="fas fa-seedling" style="color: #64748b;"></i> Safra Atual</div>
                                <div style="display:flex; justify-content:space-between; margin-bottom:5px;">
                                    <small id="safra-name">Safra --</small>
                                    <strong id="safra-progress-txt">--%</strong>
                                </div>
                                <div style="width: 100%; height: 8px; background: #f1f5f9; border-radius: 4px; overflow: hidden; margin-top: 5px;">
                                    <div id="safra-bar" style="width: 0%; height: 100%; background: #2563eb; border-radius: 4px; transition: width 0.5s;"></div>
                                </div>
                                <div style="margin-top:8px; font-size:0.75rem;"><span id="alert-sanidade">● Monitoramento OK</span></div>
                            </div>
                        </div>

                    </div>

                    <!-- RIGHT COL: Bot Feed -->
                    <div class="col-right">
                        <div class="dash-card" style="height: 100%; display: flex; flex-direction: column; background:#f0fdf4; border:1px solid #bbf7d0; padding:0; overflow:hidden; margin-bottom: 0;">
                             <div style="padding: 15px 20px; border-bottom: 1px solid #dcfce7; background: linear-gradient(to right, #ffffff, #f0fdf4); display:flex; justify-content:space-between; align-items:center;">
                                <div style="display:flex; align-items:center; gap:10px;">
                                    <div style="width: 32px; height: 32px; background: #25D366; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white;">
                                        <i class="fab fa-whatsapp"></i>
                                    </div>
                                    <div>
                                        <h4 style="margin: 0; font-size: 0.95rem; color: #14532d;">Assistente IA</h4>
                                        <span style="font-size: 0.7rem; color: #16a34a;">● Online e Monitorando</span>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-light" style="font-size:0.7rem; color:#15803d; border-color:#bbf7d0;" onclick="window.FazendaRP.loadPage('financeiro_inbox-bot')">
                                    <i class="fas fa-external-link-alt"></i> Ver Inbox
                                </button>
                             </div>
                             
                             <div id="bot-feed-list" class="bot-feed-list">
                                 <div style="text-align:center; color:#999; margin-top:20px;">
                                    <i class="fas fa-spinner fa-spin"></i> Sincronizando logs...
                                 </div>
                             </div>

                             <div style="padding:15px; background:#fff; border-top:1px solid #dcfce7;">
                                 <input type="text" placeholder="Diga algo ao bot..." 
                                    style="width:100%; padding:10px; border:1px solid #e2e8f0; border-radius:8px; font-family:'Inter'; font-size: 0.85rem;" 
                                    onkeypress="if(event.key==='Enter') window.FazendaRP.Pages.dashboard.sendBotMsg(this.value)">
                             </div>
                        </div>
                    </div>

                </div>
            </div>
        `;

        this.loadData();
    },

    // Cache for commodity prices (1 hour)
    commodityCache: {
        soja: null,
        milho: null,
        lastUpdate: null
    },

    // Fetch real commodity prices from Investing.com via CORS proxy
    fetchRealCommodityPrices: async function () {
        // Check cache (1 hour)
        const now = Date.now();
        if (this.commodityCache.lastUpdate && (now - this.commodityCache.lastUpdate) < 3600000) {
            return {
                soja: this.commodityCache.soja,
                milho: this.commodityCache.milho
            };
        }

        try {
            // Use Yahoo Finance API via CORS proxy
            // Tickers: ZS=F (Soybean Futures), ZC=F (Corn Futures)
            const baseUrl = 'https://query2.finance.yahoo.com/v8/finance/chart/';
            const proxyUrl = 'https://corsproxy.io/?';

            const [sojaRes, milhoRes] = await Promise.all([
                fetch(proxyUrl + encodeURIComponent(baseUrl + 'ZS=F')).then(r => r.json()).catch(() => null),
                fetch(proxyUrl + encodeURIComponent(baseUrl + 'ZC=F')).then(r => r.json()).catch(() => null)
            ]);

            // Extract prices from Yahoo Finance response
            const extractYahooPrice = (data) => {
                if (!data || !data.chart || !data.chart.result || !data.chart.result[0]) return null;
                const result = data.chart.result[0];
                const meta = result.meta;
                return {
                    price: meta.regularMarketPrice,
                    previousClose: meta.previousClose
                };
            };

            const sojaData = extractYahooPrice(sojaRes);
            const milhoData = extractYahooPrice(milhoRes);

            if (sojaData && milhoData) {
                // Convert from USD/bushel to BRL/saca
                // 1 bushel = 27.2 kg, 1 saca = 60 kg
                // Get real USD/BRL rate (will be available from dolar API)
                const usdToBrl = 5.95; // Will be updated with real rate
                const bushelToSaca = 60 / 27.2;

                const sojaBRL = (sojaData.price * usdToBrl * bushelToSaca).toFixed(2);
                const milhoBRL = (milhoData.price * usdToBrl * bushelToSaca).toFixed(2);

                // Calculate real percentage change
                const sojaChange = (((sojaData.price - sojaData.previousClose) / sojaData.previousClose) * 100).toFixed(2);
                const milhoChange = (((milhoData.price - milhoData.previousClose) / milhoData.previousClose) * 100).toFixed(2);

                const result = {
                    soja: {
                        symbol: 'SOJA',
                        price: sojaBRL,
                        change: sojaChange,
                        trend: parseFloat(sojaChange) >= 0 ? 'up' : 'down',
                        source: 'Yahoo Finance (Real)'
                    },
                    milho: {
                        symbol: 'MILHO',
                        price: milhoBRL,
                        change: milhoChange,
                        trend: parseFloat(milhoChange) >= 0 ? 'up' : 'down',
                        source: 'Yahoo Finance (Real)'
                    }
                };

                // Update cache
                this.commodityCache.soja = result.soja;
                this.commodityCache.milho = result.milho;
                this.commodityCache.lastUpdate = now;

                console.log('✅ Cotações reais obtidas:', result);
                return result;
            }
        } catch (error) {
            console.error('❌ Failed to fetch real commodity prices:', error);
        }

        // Return error state - NO FAKE DATA
        return {
            soja: {
                symbol: 'SOJA',
                price: '--',
                change: '--',
                trend: 'neutral',
                source: 'Erro ao buscar',
                error: true
            },
            milho: {
                symbol: 'MILHO',
                price: '--',
                change: '--',
                trend: 'neutral',
                source: 'Erro ao buscar',
                error: true
            }
        };
    },

    loadData: async function (force = false) {
        document.getElementById('last-update').innerText = new Date().toLocaleTimeString().slice(0, 5);

        // 1. Instant Hydration from Cache (Stale-While-Revalidate)
        const CACHE_KEY = 'fazenda_dash_cache';
        const rawCache = localStorage.getItem(CACHE_KEY);
        if (rawCache) {
            try {
                const cachedData = JSON.parse(rawCache);
                // Quick update with cached data to remove white screen
                this.updateUI(cachedData, true);
            } catch (e) { console.warn("Cache hydration failed:", e); }
        }

        try {
            const today = new Date();
            const todayStr = today.toISOString().split('T')[0];
            const end30d = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

            // 2. Fire all requests in Parallel (No awaiting soja/milho first)
            const pDolar = fetch('https://economia.awesomeapi.com.br/json/last/USD-BRL')
                .then(r => r.json()).catch(() => null);

            const pCommodities = this.fetchRealCommodityPrices();

            const pWeather = fetch('https://api.open-meteo.com/v1/forecast?latitude=-17.9972&longitude=-47.8216&current_weather=true&daily=weathercode,temperature_2m_max,temperature_2m_min,rain_sum,precipitation_probability_max&timezone=America%2FSao_Paulo&forecast_days=4')
                .then(r => r.json()).catch(() => null);

            // Refined Supabase selects (only needed columns)
            const pLanc = window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('descricao, valor, tipo, status, data_vencimento')
                .lte('data_vencimento', end30d)
                .neq('status', 'Cancelado');

            const pContas = window.FazendaRP.supabase
                .from('financeiro_contas')
                .select('saldo_inicial');

            const pMovsBalance = window.FazendaRP.supabase
                .from('financeiro_movimentacoes')
                .select('valor, tipo')
                .neq('status', 'Cancelado');

            const pSafra = window.FazendaRP.supabase
                .from('safras')
                .select('cultura, ano')
                .order('ano', { ascending: false })
                .limit(1);

            const pFrota = window.FazendaRP.supabase
                .from('frota')
                .select('status');

            const pEstoque = window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('item_nome, saldo_atual, unidade')
                .ilike('item_nome', '%DIESEL%');

            const pBotFeed = window.FazendaRP.supabase
                .from('financeiro_pre_lancamentos')
                .select('id, texto_bruto, valor:dados_extraidos->>valor, created_at, status, origem_tipo, tipo_arquivo, dados_extraidos')
                .order('created_at', { ascending: false })
                .limit(10);

            const [dolar, commodities, weather, resLanc, resContas, resMovs, resSafra, resFrota, resEstoque, resBotFeed] = await Promise.all([
                pDolar, pCommodities, pWeather, pLanc, pContas, pMovsBalance, pSafra, pFrota, pEstoque, pBotFeed
            ]);

            const finalData = {
                dolar: dolar,
                soja: commodities?.soja || { price: '--', change: '--', trend: 'neutral' },
                milho: commodities?.milho || { price: '--', change: '--', trend: 'neutral' },
                weather: weather,
                movs: resLanc.data || [],
                contas: resContas.data || [],
                movs_balance: resMovs.data || [],
                safra: resSafra.data ? resSafra.data[0] : null,
                frota: resFrota.data || [],
                estoque: resEstoque.data || [],
                botFeed: resBotFeed.data || []
            };

            // 3. Save to Cache for next reload
            localStorage.setItem(CACHE_KEY, JSON.stringify(finalData));

            // 4. Final UI Update
            this.lastData = finalData;
            this.updateUI(finalData);

        } catch (err) {
            console.error("Dashboard Async Error:", err);
            // Even if it fails, the UI might still have the cached data
        }
    },

    updateUI: function (data, isHydration = false) {
        const fmtMoney = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const today = new Date();
        const todayStr = today.toISOString().split('T')[0];

        // Helper to safely set element content
        const safeSet = (id, value) => {
            const el = document.getElementById(id);
            if (el) el.innerText = value;
        };

        // Current Balance (Initial + Movements)
        const initialSum = data.contas.reduce((acc, c) => acc + (parseFloat(c.saldo_inicial) || 0), 0);
        const movsSum = data.movs_balance.reduce((acc, m) => {
            const val = parseFloat(m.valor) || 0;
            return acc + (m.tipo === 'CREDITO' ? val : -val);
        }, 0);
        const currentBalance = initialSum + movsSum;
        safeSet('dash-saldo', fmtMoney(currentBalance));

        const next30d = data.movs.filter(l => l.data_vencimento >= todayStr && (l.status || '').toUpperCase() !== 'PAGO');
        const projRec = next30d.filter(l => (l.tipo || '').toUpperCase() === 'RECEITA').reduce((acc, l) => acc + parseFloat(l.valor), 0);
        const projDesp = next30d.filter(l => (l.tipo || '').toUpperCase() === 'DESPESA').reduce((acc, l) => acc + parseFloat(l.valor), 0);

        safeSet('dash-rec-30d', fmtMoney(projRec));
        safeSet('dash-desp-30d', fmtMoney(projDesp));

        // --- 0.2 Overdue (Vencidos) ---
        const overdue = data.movs.filter(l => l.data_vencimento < todayStr && (l.tipo || '').toUpperCase() === 'DESPESA' && (l.status || '').toUpperCase() !== 'PAGO');
        const cardVencidos = document.getElementById('card-vencidos');
        if (cardVencidos) {
            if (overdue.length > 0) {
                cardVencidos.style.display = 'block';
                safeSet('count-vencidos', overdue.length);
            } else {
                cardVencidos.style.display = 'none';
            }
        }

        // --- 0. Ticker ---
        if (data.dolar && data.dolar.USDBRL) {
            const usd = data.dolar.USDBRL;
            const val = parseFloat(usd.bid).toFixed(2);
            const pct = parseFloat(usd.pctChange);
            const icon = pct >= 0 ? '▲' : '▼';
            const colorClass = pct >= 0 ? 'up' : 'down';
            safeSet('val-dolar', `R$ ${val}`);
            safeSet('pct-dolar', `${icon} ${pct}%`);
            const pctEl = document.getElementById('pct-dolar');
            if (pctEl) pctEl.className = `ticker-val ${colorClass}`;
        }

        // Update Soja
        if (data.soja) {
            const icon = data.soja.trend === 'up' ? '▲' : '▼';
            safeSet('val-soja', `R$ ${data.soja.price}`);
            safeSet('pct-soja', `${icon} ${Math.abs(data.soja.change)}%`);
            const pctSoja = document.getElementById('pct-soja');
            if (pctSoja) pctSoja.className = `ticker-val ${data.soja.trend}`;
        }

        // Update Milho
        if (data.milho) {
            const icon = data.milho.trend === 'up' ? '▲' : '▼';
            safeSet('val-milho', `R$ ${data.milho.price}`);
            safeSet('pct-milho', `${icon} ${Math.abs(data.milho.change)}%`);
            const pctMilho = document.getElementById('pct-milho');
            if (pctMilho) pctMilho.className = `ticker-val ${data.milho.trend}`;
        }

        // Due Next 7 Days
        const date7d = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
        const next7d = data.movs.filter(l => l.data_vencimento >= todayStr && l.data_vencimento <= date7d && (l.tipo || '').toUpperCase() === 'DESPESA' && (l.status || '').toUpperCase() !== 'PAGO');
        safeSet('count-pagar-hoje', next7d.length);

        const listContainer = document.getElementById('list-vencendo-hoje');
        if (listContainer) {
            if (next7d.length === 0) {
                listContainer.innerHTML = '<div style="text-align:center; color:#94a3b8; font-size:0.8rem; padding:15px; background: #f8fafc; border-radius: 8px;">Nada vencendo nos próximos 7 dias! 🎉</div>';
            } else {
                listContainer.innerHTML = next7d.map(l => {
                    const dv = new Date(l.data_vencimento + 'T12:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
                    const isToday = l.data_vencimento.startsWith(todayStr);
                    return `
                        <div class="kpi-row">
                            <div style="font-size:0.85rem; font-weight:500; color:#334155;">
                                <span style="font-size:0.7rem; color:${isToday ? '#ef4444' : '#64748b'}; font-weight:700;">${dv}</span> ${l.descricao}
                            </div>
                            <div style="font-weight:600; color:#dc2626;">${fmtMoney(parseFloat(l.valor))}</div>
                        </div>
                    `;
                }).join('');
            }
        }

        // --- 2. Diesel (Novo Filtro) ---
        const estoqueCont = document.getElementById('estoque-critico-list');
        if (estoqueCont) {
            if (data.estoque && data.estoque.length > 0) {
                const dieselItems = data.estoque.filter(item => {
                    const name = item.item_nome.toUpperCase();
                    return name === 'DIESEL S500' || name === 'DIESEL S-500';
                });

                if (dieselItems.length > 0) {
                    estoqueCont.innerHTML = dieselItems.map(item => {
                        const saldo = parseFloat(item.saldo_atual) || 0;
                        const percent = Math.min(100, (saldo / 2000) * 100); // Mock limit 2000L
                        const color = percent < 25 ? '#ef4444' : '#ea580c';
                        return `
                        <div style="margin-bottom: 12px;">
                            <div style="display: flex; justify-content: space-between; margin-bottom: 5px; font-size: 0.85rem;">
                                <span style="font-weight: 500;">${item.item_nome}</span>
                                <span style="font-weight: 700;">${saldo.toFixed(0)}${item.unidade}</span>
                            </div>
                            <div style="height: 6px; background: #f1f5f9; border-radius: 3px; overflow: hidden;">
                                <div style="width: ${percent}%; height: 100%; background: ${color};"></div>
                            </div>
                        </div>
                    `;
                    }).join('');
                } else {
                    estoqueCont.innerHTML = '<div style="text-align:center; color:#94a3b8; font-size:0.8rem; padding:10px;">Sem alertas de diesel.</div>';
                }
            } else {
                estoqueCont.innerHTML = '<div style="text-align:center; color:#94a3b8; font-size:0.8rem; padding:10px;">Sem dados de estoque.</div>';
            }
        }

        // --- 3. Safra & Frota ---
        if (data.safra) {
            safeSet('safra-name', `${data.safra.cultura} ${data.safra.ano}`);
            safeSet('safra-progress-txt', '85%'); // Mock progress
            const safraBar = document.getElementById('safra-bar');
            if (safraBar) safraBar.style.width = '85%';
        }

        const totalF = data.frota.length;
        const activeF = data.frota.filter(m => (m.status || '').toLowerCase() === 'ativo' || (m.status || '').toLowerCase() === 'operando').length;
        const maintF = totalF - activeF;
        safeSet('frota-total', activeF);
        safeSet('frota-sub', `/ ${totalF}`);

        const frotaManut = document.getElementById('frota-manut');
        if (frotaManut) {
            frotaManut.innerHTML = maintF > 0 ? `● ${maintF} na oficina` : '● Tudo operante';
            frotaManut.style.color = maintF > 0 ? '#dc2626' : '#16a34a';
        }

        // --- 4. Weather ---
        if (data.weather) {
            const cur = data.weather.current_weather;
            const daily = data.weather.daily || {};

            // Map weather codes to FontAwesome icons and descriptions
            const weatherMap = {
                0: { icon: 'fa-sun', desc: 'Céu Limpo', color: '#fbbf24', bg: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' },
                1: { icon: 'fa-cloud-sun', desc: 'Pouca Nebulosidade', color: '#fcd34d', bg: 'linear-gradient(135deg, #38bdf8 0%, #0369a1 100%)' },
                2: { icon: 'fa-cloud-sun', desc: 'Parcial. Nublado', color: '#fcd34d', bg: 'linear-gradient(135deg, #475569 0%, #1e293b 100%)' },
                3: { icon: 'fa-cloud', desc: 'Nublado', color: '#94a3b8', bg: 'linear-gradient(135deg, #64748b 0%, #334155 100%)' },
                45: { icon: 'fa-smog', desc: 'Nevoeiro', color: '#94a3b8', bg: 'linear-gradient(135deg, #94a3b8 0%, #475569 100%)' },
                48: { icon: 'fa-smog', desc: 'Nevoeiro', color: '#94a3b8', bg: 'linear-gradient(135deg, #94a3b8 0%, #475569 100%)' },
                51: { icon: 'fa-cloud-rain', desc: 'Garoa', color: '#60a5fa', bg: 'linear-gradient(135deg, #1e3a8a 0%, #1e1b4b 100%)' },
                53: { icon: 'fa-cloud-rain', desc: 'Garoa', color: '#60a5fa', bg: 'linear-gradient(135deg, #1e3a8a 0%, #1e1b4b 100%)' },
                55: { icon: 'fa-cloud-rain', desc: 'Garoa', color: '#60a5fa', bg: 'linear-gradient(135deg, #1e3a8a 0%, #1e1b4b 100%)' },
                61: { icon: 'fa-cloud-showers-heavy', desc: 'Chuva Leve', color: '#3b82f6', bg: 'linear-gradient(135deg, #1e40af 0%, #0f172a 100%)' },
                63: { icon: 'fa-cloud-showers-heavy', desc: 'Chuva', color: '#2563eb', bg: 'linear-gradient(135deg, #1e40af 0%, #0f172a 100%)' },
                65: { icon: 'fa-cloud-showers-heavy', desc: 'Chuva Forte', color: '#1d4ed8', bg: 'linear-gradient(135deg, #0f172a 0%, #020617 100%)' },
                80: { icon: 'fa-cloud-showers-heavy', desc: 'Pancadas', color: '#3b82f6', bg: 'linear-gradient(135deg, #1e40af 0%, #0f172a 100%)' },
                81: { icon: 'fa-cloud-showers-heavy', desc: 'Pancadas', color: '#2563eb', bg: 'linear-gradient(135deg, #1e40af 0%, #0f172a 100%)' },
                82: { icon: 'fa-cloud-showers-heavy', desc: 'Pancadas Fortes', color: '#1d4ed8', bg: 'linear-gradient(135deg, #0f172a 0%, #020617 100%)' },
                95: { icon: 'fa-cloud-bolt', desc: 'Tempestade', color: '#fbbf24', bg: 'linear-gradient(135deg, #4c1d95 0%, #1e1b4b 100%)' },
            };

            const curWeather = weatherMap[cur.weathercode] || { icon: 'fa-cloud-sun', desc: 'Variável', color: '#fff', bg: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)' };

            // Update Background and Hero
            const weatherGlass = document.querySelector('.weather-glass');
            if (weatherGlass) {
                weatherGlass.style.background = curWeather.bg;
                weatherGlass.style.transition = 'background 1s ease-in-out';
            }

            safeSet('hero-temp', Math.round(cur.temperature) + "°C");
            safeSet('hero-cond', curWeather.desc);
            const heroIcon = document.getElementById('hero-icon');
            if (heroIcon) {
                heroIcon.className = `fas ${curWeather.icon} fa-3x`;
                heroIcon.style.color = 'white';
            }

            // Update Meta
            // Approximate humidity from weather code or use fallback since we removed specific humidity fetch for current
            safeSet('hero-humidity', (cur.weathercode > 50 ? '80%' : '65%'));
            safeSet('hero-wind', cur.windspeed + " km/h");
            safeSet('ticker-weather', `${curWeather.icon === 'fa-sun' ? '☀️' : '🌤️'} Catalão: ${Math.round(cur.temperature)}°C`);

            // Spraying Logic (simplified check)
            const sprayingEl = document.getElementById('hero-spraying');
            const badgeSpraying = document.getElementById('badge-spraying');
            if (sprayingEl && badgeSpraying) {
                if (cur.windspeed < 12 && cur.weathercode < 51) {
                    sprayingEl.innerText = 'PULVERIZAÇÃO: OK';
                    badgeSpraying.style.background = 'rgba(16, 185, 129, 0.4)';
                } else {
                    sprayingEl.innerText = 'PULVERIZAÇÃO: ATENÇÃO';
                    badgeSpraying.style.background = 'rgba(239, 68, 68, 0.4)';
                }
            }

            // --- Forecast Rendering ---
            const forecastCont = document.getElementById('weather-forecast');
            if (forecastCont && daily.time) {
                const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

                // Show Tomorrow, Day+2, Day+3 (skip index 0 as it's today)
                let forecastHTML = '';
                for (let i = 1; i <= 3; i++) {
                    const date = new Date(daily.time[i] + 'T12:00:00');
                    const dayName = days[date.getDay()];
                    const code = daily.weathercode[i];
                    const w = weatherMap[code] || { icon: 'fa-cloud-sun', desc: 'Variável' };
                    const max = Math.round(daily.temperature_2m_max[i]);
                    const min = Math.round(daily.temperature_2m_min[i]);
                    const rain = daily.rain_sum[i] || 0;
                    const prob = daily.precipitation_probability_max[i] || 0;

                    const isAlert = prob > 50 || rain > 5;

                    forecastHTML += `
                        <div class="forecast-day-mini">
                            <div style="font-size: 0.65rem; font-weight: 800; opacity: 0.7; margin-bottom: 8px; text-transform: uppercase;">${dayName}</div>
                            <i class="fas ${w.icon}" style="font-size: 1.5rem; margin-bottom: 10px; display: block; color: ${isAlert ? '#93c5fd' : 'white'};"></i>
                            <div style="font-size: 0.9rem; font-weight: 700;">${max}° <span style="opacity: 0.6; font-size: 0.75rem;">${min}°</span></div>
                            ${prob > 0 ? `
                                <div style="font-size: 0.65rem; color: ${isAlert ? '#93c5fd' : 'rgba(255,255,255,0.7)'}; font-weight: 700; margin-top: 4px;">
                                    <i class="fas fa-droplet" style="font-size: 0.5rem;"></i> ${prob}%
                                </div>
                            ` : ''}
                        </div>
                    `;
                }
                forecastCont.innerHTML = forecastHTML;
            }
        }

        // --- 5. Bot Feed ---
        const feedCont = document.getElementById('bot-feed-list');
        const pendingItems = (data.botFeed || []).filter(item => item.status === 'pendente');

        if (feedCont) {
            if (pendingItems.length > 0) {
                feedCont.innerHTML = pendingItems.map(item => {
                    const isPending = item.status === 'pendente';
                    const d = item.dados_extraidos || {};
                    const valor = d.valor ? fmtMoney(parseFloat(d.valor)) : '';
                    const title = d.empresa || d.fornecedor || 'Documento';
                    const timeStr = this.formatTimeAgo(item.created_at);

                    let icon = 'fa-file-lines';
                    let pkg = 'fas';
                    let iconColor = '#6366f1';

                    if (item.origem_tipo?.includes('whatsapp')) {
                        icon = 'fa-whatsapp';
                        pkg = 'fab';
                        iconColor = '#25D366';
                    }
                    if (item.origem_tipo === 'web_dashboard') { icon = 'fa-user'; iconColor = '#6366f1'; }
                    if (item.tipo_arquivo === 'imagem') { icon = 'fa-image'; iconColor = '#f59e0b'; }
                    if (item.tipo_arquivo === 'audio') { icon = 'fa-microphone'; iconColor = '#8b5cf6'; }

                    return `
                        <div class="bot-feed-item">
                            <div class="bot-icon" style="color: ${iconColor};"><i class="${pkg} ${icon}"></i></div>
                            <div style="flex:1;">
                                <div style="font-weight:600; font-size:0.85rem; color:#1e293b;">${title}</div>
                                <div style="font-size:0.75rem; color:#64748b; margin-bottom: 5px;">${valor ? valor + ' • ' : ''}${isPending ? 'Aguardando aprovação' : 'Processado'}</div>
                                <div style="font-size:0.65rem; color:#94a3b8;">${timeStr}</div>
                            </div>
                        </div>
                    `;
                }).join('');
            } else {
                feedCont.innerHTML = '<div style="text-align:center; color:#94a3b8; font-size:0.8rem; padding:40px;">Nenhuma tarefa pendente no momento.</div>';
            }
        }

        this.renderChart(data.movs);
    },

    formatTimeAgo: function (dateStr) {
        const date = new Date(dateStr);
        const diff = (new Date() - date) / 1000;
        if (diff < 60) return 'Agora mesmo';
        if (diff < 3600) return `Há ${Math.floor(diff / 60)} min`;
        if (diff < 86400) return `Há ${Math.floor(diff / 3600)} h`;
        return date.toLocaleDateString('pt-BR');
    },

    renderChart: function (movs) {
        const ctx = document.getElementById('mainChart');
        if (!ctx) return;

        const labels = [];
        const dataRec = [];
        const dataDesp = [];

        const today = new Date();
        for (let i = 5; i >= 0; i--) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            const mStr = d.toISOString().slice(0, 7);
            labels.push(d.toLocaleDateString('pt-BR', { month: 'short' }).replace('.', ''));

            const monthMovs = movs.filter(l => l.data_vencimento.startsWith(mStr));
            const rec = monthMovs.filter(l => (l.tipo || '').toUpperCase() === 'RECEITA').reduce((a, b) => a + parseFloat(b.valor), 0);
            const desp = monthMovs.filter(l => (l.tipo || '').toUpperCase() === 'DESPESA').reduce((a, b) => a + parseFloat(b.valor), 0);

            dataRec.push(rec);
            dataDesp.push(desp);
        }

        if (window.dashChartInstance) window.dashChartInstance.destroy();

        const gradient = ctx.getContext('2d').createLinearGradient(0, 0, 0, 300);
        gradient.addColorStop(0, 'rgba(5, 150, 105, 0.1)');
        gradient.addColorStop(1, 'rgba(5, 150, 105, 0)');

        window.dashChartInstance = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Receitas',
                        data: dataRec,
                        borderColor: '#059669',
                        backgroundColor: gradient,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 3,
                        pointRadius: 4,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: '#059669'
                    },
                    {
                        label: 'Despesas',
                        data: dataDesp,
                        borderColor: '#ef4444',
                        borderDash: [5, 5],
                        fill: false,
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 0
                    }
                ]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                plugins: {
                    legend: { display: true, position: 'top', align: 'end', labels: { usePointStyle: true, boxWidth: 6, font: { family: 'Inter', size: 11 } } },
                    tooltip: { backgroundColor: '#1e293b', padding: 12, cornerRadius: 10, titleFont: { size: 13, family: 'Outfit' } }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: { color: '#f1f5f9', borderDash: [2, 2] },
                        ticks: { font: { size: 10 }, color: '#94a3b8', callback: v => 'R$' + v / 1000 + 'k' }
                    },
                    x: { grid: { display: false }, ticks: { font: { size: 10 }, color: '#94a3b8' } }
                }
            }
        });
    },

    sendBotMsg: async function (text) {
        if (!text || text.trim() === '') return;

        window.FazendaRP.Toast.show('info', 'Bot', 'Enviando sua mensagem para a IA...');

        try {
            const { error } = await window.FazendaRP.supabase
                .from('financeiro_pre_lancamentos')
                .insert([
                    {
                        origem_tipo: 'web_dashboard',
                        origem_id: 'User',
                        tipo_arquivo: 'texto',
                        texto_bruto: text,
                        status: 'pendente',
                        dados_extraidos: { info: "Mensagem via Dashboard" }
                    }
                ]);

            if (error) throw error;

            // Clear input
            const input = document.querySelector('.col-right input');
            if (input) input.value = '';

            // Reload feed
            this.loadData();

        } catch (err) {
            console.error('Error sending bot msg:', err);
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao enviar mensagem ao bot.');
        }
    },

    handleBotAction: async function (action, id) {
        // Dynamic Loader Helper
        const loadModule = async (path, cleanupCheck) => {
            if (cleanupCheck()) return true;
            return new Promise(r => {
                const s = document.createElement('script');
                s.src = path;
                s.onload = () => r(true);
                s.onerror = () => { console.error("Failed to load " + path); r(false); };
                document.head.appendChild(s);
            });
        };

        // 1. Ensure Inbox Logic AND Movimentacoes (for Modal) Logic is present
        // Use sequential loading to be safe
        const inboxReady = await loadModule('js/pages/financeiro/inbox.js', () => window.FazendaRP.Pages.financeiro && window.FazendaRP.Pages.financeiro.inbox);

        if (!inboxReady) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao carregar dependências.');
            return;
        }

        const inbox = window.FazendaRP.Pages.financeiro.inbox;

        // Mock items context
        if (!inbox.items) inbox.items = [];
        const item = this.lastData && this.lastData.botFeed ? this.lastData.botFeed.find(i => i.id === id) : null;
        if (item && !inbox.items.some(i => i.id === id)) inbox.items.push(item);


        if (action === 'rejeitar') {
            await inbox.rejeitar(id);
            this.loadData();

        } else if (action === 'pagar') {
            // Try to load Movimentacoes for Modal
            window.FazendaRP.Toast.show('info', 'Carregando...', 'Abrindo modal de pagamento...');
            const movsReady = await loadModule('js/pages/financeiro/movimentacoes.js', () => window.FazendaRP.Pages.financeiro && window.FazendaRP.Pages.financeiro.renderTransferenciaModal);

            if (movsReady) {
                // Monkey-patch loadData to refresh Dashboard
                const backupLoad = inbox.loadData;
                inbox.loadData = () => this.loadData();

                await inbox.openQuickPay(id);

                inbox.loadData = backupLoad; // Restore
            } else {
                // Fallback to redirect
                localStorage.setItem('bot_action_pending', JSON.stringify({ action, id }));
                if (window.FazendaRP.loadPage) window.FazendaRP.loadPage('inbox');
            }

        } else if (action === 'aprovar') {
            // Full Form -> Must Redirect
            localStorage.setItem('bot_action_pending', JSON.stringify({ action, id }));
            window.FazendaRP.Toast.show('info', 'Aprovar', 'Abrindo lançamento completo...');
            if (window.FazendaRP.loadPage) window.FazendaRP.loadPage('inbox');
        }
    }
};

